import type { Theme } from '@mui/material';

import { useEffect } from 'react';
import { useSearchParams } from 'react-router';

import {
  Box,
  Checkbox,
  TextField,
  FormGroup,
  Typography,
  useMediaQuery,
  FormControlLabel,
} from '@mui/material';

import { Scrollbar } from 'src/components/scrollbar';

export const PriceFilter = (props: { filters: any; setFilters: React.Dispatch<any> }) => {
  const { filters, setFilters } = props;
  const downSm = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  const [searchParams] = useSearchParams();
  const fee = searchParams.get('ucret') || null;
  const minPrice = searchParams.get('min') || null;
  const maxPrice = searchParams.get('max') || null;

  const handleChange = (value: string) => {
    const newPrice = filters.fee === value ? null : value;

    setFilters((prev: any) => ({
      ...prev,
      fee: newPrice,
      price: {
        ...prev.price,
        // from: minPrice ? parseInt(minPrice, 10) : null,
        // to: maxPrice ? parseInt(maxPrice, 10) : null,
      }
    }));
  };

  const handlePriceChange = (field: 'from' | 'to', value: string) => {
    setFilters((prev: any) => ({
      ...prev,
      price: {
        ...prev.price,
        [field]: value ? parseInt(value, 10) : null,
      },
    }));
  };

  useEffect(() => {
    if (fee !== null) {
      setFilters((prev: any) => ({
        ...prev,
        fee,
      }));
    }
  }, [fee, setFilters]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1 }}>
        Fiyat
      </Typography>

      <Scrollbar sx={{ maxHeight: 164 }}>
        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox
                checked={filters.fee === 'paid'}
                onChange={() => handleChange('paid')}
                sx={{ py: 0.25 }}
              />
            }
            label="Ücretli"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={filters.fee === 'free'}
                onChange={() => handleChange('free')}
                sx={{ py: 0.25 }}
              />
            }
            label="Ücretsiz"
          />
        </FormGroup>
        {filters.fee === 'paid' && (
          <Box sx={{ mt: 2 }}>
            <TextField
              label="Min Fiyat"
              variant="outlined"
              size="small"
              value={filters.price.from || ''}
              onChange={(e) => handlePriceChange('from', e.target.value)}
              sx={{ mb: 2 }}
            />
            <TextField
              label="Max Fiyat"
              variant="outlined"
              size="small"
              value={filters.price.to || ''}
              onChange={(e) => handlePriceChange('to', e.target.value)}
            />
          </Box>
        )}
        {/* {filters.fee === 'free' && (
          <Typography variant="body2" sx={{ mt: 2 }}>
            Ücretsiz etkinlikler için fiyat aralığı belirlenemez.
          </Typography>
        )} */}
      </Scrollbar>
    </Box>
  );
};
